module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA6UlEQVR4AdWSA0wuABgA//FlzMsYc3ND1lSzzZqZbducMobsIdu2beuy3dS77cZvnwV/g6BMN9S9hdGNEvqRjwkAGjpasPKT/X2CGzaWt6nLM+CwSQC9X/oywdl5B9sxJuzllFKVnkSLojSTSlKf+TLBmqcNewXCbLhosBcaSF9hPlkaqgwpfjPBerQtm8WirJf+YzVejxvGl5YRFha+CXzPlwmOl6tYLBRhrkCY48VIhnoGyFRX+X4HZ6sLXG73cLrVR5mvPc0/3cEN27vn1BVa/u4KzZ3tWPv+8g9CsjxQ9xL5/Sf+31wBrJtuXroTVscAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ZW.png
// module id = 1308
// module chunks = 0